import { event } from '@eb/event-create-publish-utils';
import { api as privacyApi } from '@eb/privacy-settings';

const {
    api: { schedulePublishErrorSpec },
} = event;

const {
    getEventScheduleToPublish,
    deleteEventSchedulePrivateToPublish,
} = privacyApi;

export const deleteSchedulePublishToPublicTimerAction = (eventId) => async (
    dispatch,
    getState,
) => {
    const {
        eventTimeZone,
        featureFlags: { enableEventPrivacyScheduleUI },
    } = getState();
    await deleteSchedulePublishToPublicTimer(
        eventId,
        eventTimeZone,
        enableEventPrivacyScheduleUI,
    );
};

export const deleteSchedulePublishToPublicTimer = async (
    eventId,
    eventTimeZone,
    enableEventPrivacyScheduleUI,
) => {
    if (enableEventPrivacyScheduleUI) {
        if (!eventId) {
            return;
        }

        try {
            const schedulePrivacySettings = await getEventScheduleToPublish(
                schedulePublishErrorSpec,
                eventId,
                eventTimeZone,
            );
            if (schedulePrivacySettings) {
                await deleteEventSchedulePrivateToPublish(
                    schedulePublishErrorSpec,
                    schedulePrivacySettings.id,
                );
            }
        } catch {
            return;
        }
    }
};
